class CartUpsellItem extends HTMLElement{
  constructor(){
    super()

    this.swatches = this.querySelectorAll('.color-swatch')
    this.form = this.querySelector('form')
    this.colorLabel = this.querySelector('.color-swatch-title')
    this.variantsData = JSON.parse(this.getAttribute('data-variants-data'));
    this.numOptions = this.getAttribute('data-num-options');
    this.option2Select = this.querySelector('#color-selector-extra-label');

    this.init()

    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.handleClick.bind(this))
    })
    
    // Add event listener to option2 select if it exists
    if (this.option2Select) {
      this.option2Select.addEventListener('change', this.handleOptionChange.bind(this))
    }
  }

  init(){
    //Remove out of stock variants
    if(this.numOptions == 1){
        Object.values(this.variantsData).forEach((variant, index) => {
            if(!variant.available){
                this.querySelector('.color-swatch[data-id="'+Object.keys(this.variantsData)[index]+'"]').remove();
            }
        })

        this.swatches = this.querySelectorAll('.color-swatch');
    }

    //Select first swatch
    this.swatches[0].setAttribute('id', 'active-border');
    let inputValue = this.swatches[0].previousElementSibling.value;
    this.swatches[0].setAttribute('value', inputValue);
    this.colorLabel && (this.colorLabel.textContent = this.swatches[0].getAttribute('data-text'));
    this.form.querySelector('.product-variant-id').value = inputValue;

    //Hide swatches after the 3rd one
    this.swatches.forEach((swatch, index) => {
        index > 3 && swatch.classList.add("hidden")
    })

    //Add plus and row if there are more than 3 swatches
    if(this.swatches.length > 4){
        let newPlus = document.createElement('div');
        newPlus.classList.add('label-selector-extra');
        newPlus.classList.add('color-swatch-plus');
        newPlus.textContent = '+' + (this.swatches.length - 4);
        newPlus.style.fontSize = '1.5rem';
        newPlus.style.fontWeight = '500';
        newPlus.style.marginTop = '0!important';
        newPlus.style.marginLeft = '0.5rem';
        this.querySelector('.label-selector-extra').appendChild(newPlus)

        let newRow = document.createElement('img');
        newRow.src = 'https://cdn.shopify.com/s/files/1/0421/8480/2468/files/Arrow-left.svg?v=1715241179';
        newRow.style.width = '100%';
        newRow.style.maxWidth = '3rem';
        newRow.style.marginRight = '0.5rem';

        //Add event listener to the plus
        newPlus.addEventListener('click', () => {
            for (let i = 4; i < this.swatches.length; i++) {
              this.swatches[i].classList.remove("hidden");
              newRow.style.display = 'block';
              newRow.style.cursor = 'pointer';
              this.querySelector('.label-selector-extra').prepend(newRow);
            }

            for (let i = 0; i <= 3; i++) {
              this.swatches[i].classList.add('hidden');
            }
            newPlus.style.display = 'none';
          });

          newRow.addEventListener('click', () => {
            for (let i = 4; i < this.swatches.length; i++) {
              this.swatches[i].classList.add("hidden");
              newRow.style.display = 'none';
              this.querySelector('.label-selector-extra').appendChild(newPlus);
            }

            for (let i = 0; i <= 3; i++) {
              this.swatches[i].classList.remove("hidden");
            }
            newPlus.style.display = 'flex';
          });
    }
  }

  handleClick(event){
    this.swatches.forEach(swatch => {
        swatch.removeAttribute('id');
    })
    event.target.setAttribute('id', 'active-border');
    if(parseInt(this.numOptions) == 1){
        let inputValue = event.target.previousElementSibling.value;
        event.target.setAttribute('value', inputValue);
        this.colorLabel && (this.colorLabel.textContent = event.target.getAttribute('data-text'));
        this.form.querySelector('.product-variant-id').value = inputValue;
        this.handleImageChange(inputValue)
    }else{
        const option1 = Array.from(this.swatches).find(swatch => swatch.getAttribute('id') == "active-border").getAttribute('name').split(" / ")[0];
        const selectElement = this.querySelector('#color-selector-extra-label');
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const option2 = selectedOption.getAttribute('data-option-value');


        // Find the variant that matches both options
        const selectedVariant = Object.values(this.variantsData).map((variant, index) => {
            if(variant.option1 === option1 && variant.option2 === option2){
                if(!variant.available){
                    this.querySelector('.buy-button-extra').classList.add('disabled');
                    this.querySelector('.buy-button-extra').setAttribute('disabled', 'disabled');
                }else{
                    this.querySelector('.buy-button-extra').classList.remove('disabled');
                    this.querySelector('.buy-button-extra').removeAttribute('disabled');
                }
                return Object.keys(this.variantsData)[index]
            }
        }).find(variant => variant !== undefined);
        

        if (selectedVariant) {
            this.form.querySelector('.product-variant-id').value = selectedVariant;
            this.handleImageChange(selectedVariant)
        }
    }
  }

  handleImageChange(variantId){
    const images = this.querySelectorAll('.img-cart')
    images.forEach(image => {
      if(image.getAttribute('data-variant-id') == variantId){
        image.style.display = 'block'
      }else{
        image.style.display = 'none'
      }
    })
  }

  handleOptionChange(event) {
    // Find the currently active swatch
    const activeSwatch = Array.from(this.swatches).find(swatch => swatch.getAttribute('id') === "active-border");
    
    // If there's an active swatch, simulate a click on it to update the selection
    if (activeSwatch) {
      this.handleClick({ target: activeSwatch });
    }
  }
}

customElements.define('cart-upsell-item', CartUpsellItem)
